import React from 'react'
import styled from 'styled-components'
import {
  Typography,
  Grid,
  Card,
} from '@material-ui/core'
import * as yup from 'yup'
import {Formik} from 'formik'
import {toast} from 'react-toastify'
import PropTypes from 'prop-types'
import {
  GridItem,
  GRID_CONTAINER_SPACING,
  SaveButton,
  FormikSelect,
} from './common'
import {PRODUCT_DISPLAY_SETTING_LABEL} from '../../../../../../constant'

const Title = styled(Typography)`
  display: flex;
  justify-content: space-between;
  margin-bottom: 20px;
`

const SectionCard = styled(Card)`
  padding: 20px;
  margin-bottom: 20px;
`

const SEARCH_ORDER_TYPE_MENU = [
  {
    label: PRODUCT_DISPLAY_SETTING_LABEL.SEARCH_ORDER_LABEL.LAST_CREATED,
    value: PRODUCT_DISPLAY_SETTING_LABEL.SEARCH_ORDER_TYPE.LAST_CREATED,
  },
  {
    label: PRODUCT_DISPLAY_SETTING_LABEL.SEARCH_ORDER_LABEL.FIRST_CREATED,
    value: PRODUCT_DISPLAY_SETTING_LABEL.SEARCH_ORDER_TYPE.FIRST_CREATED,
  },
]

const validationSchema = yup.object({
  searchProductsOrder: yup.string().matches(/(FIRST_CREATED|LAST_CREATED)/, PRODUCT_DISPLAY_SETTING_LABEL.SELECT_SEARCH_ORDER__ERROR),
})

class ProductDisplaySettingSector extends React.Component {
  render() {
    return (
      <SectionCard>
        <Formik
          enableReinitialize
          initialValues={{
            searchProductsOrder: this.props.value,
          }}
          onSubmit={(values, {setSubmitting}) => {
            this.props
              .onSave({
                variables: {
                  projectId: this.props.projectId,
                  searchProductsOrder: values.searchProductsOrder,
                },
              })
              .then(re => {
                setSubmitting(false)
                toast.success(
                  PRODUCT_DISPLAY_SETTING_LABEL.SAVE_SUCCESS,
                  {
                    hideProgressBar: true,
                    position: toast.POSITION.BOTTOM_RIGHT,
                  },
                )
              })
          }}
          validationSchema={validationSchema}
          render={props => {
            const {
              isSubmitting,
              handleSubmit,
              handleChange,
              handleBlur,
              touched,
              errors,
              values,
            } = props
            return (
              <form onSubmit={handleSubmit}>
                <Title variant="title">
                  {PRODUCT_DISPLAY_SETTING_LABEL.TITLE}
                </Title>
                <Grid container spacing={GRID_CONTAINER_SPACING}>
                  <GridItem item xs={12} sm="auto">
                    <Typography align="center" variant="body1">
                      {PRODUCT_DISPLAY_SETTING_LABEL.SEARCH_ORDER}
                    </Typography>
                  </GridItem>
                  <GridItem item xs={12} sm={2}>
                    <FormikSelect
                      onBlur={handleBlur}
                      touched={touched}
                      errors={errors}
                      value={values.searchProductsOrder}
                      onChange={handleChange}
                      listItems={SEARCH_ORDER_TYPE_MENU}
                      name="searchProductsOrder"
                    />
                  </GridItem>
                  <Grid
                    container
                    direction="row-reverse"
                    spacing={GRID_CONTAINER_SPACING}
                  >
                    <GridItem item xs={12} sm={3}>
                      <SaveButton
                        type="submit"
                        variant="contained"
                        disabled={isSubmitting}
                        fullWidth
                      >
                        {PRODUCT_DISPLAY_SETTING_LABEL.SAVE}
                      </SaveButton>
                    </GridItem>
                  </Grid>
                </Grid>
              </form>
            )
          }}
        />
      </SectionCard>
    )
  }
}

ProductDisplaySettingSector.propTypes = {
  value: PropTypes.string.isRequired,
  onSave: PropTypes.func.isRequired,
  projectId: PropTypes.string.isRequired,
}

export default ProductDisplaySettingSector



// WEBPACK FOOTER //
// ./src/main/content/project/ecommerce/storeSettings/components/ProductDisplaySettingSector.js